import { $Q, $Qll } from "../utils/query-selector";
import { resetAndPauseVideo } from "./video-player";
import Swiper from "swiper";
import { Navigation, Pagination, Mousewheel, Thumbs, EffectFade } from 'swiper/modules';



export const mainProductSwiper = (query = '') => {
  let swiperProductThumbs = $Q(`#productMainSliderThumbs`);
  let swiperProductSlider = $Q(`#productMainSlider`);
  let productHandle = swiperProductSlider?.dataset.handle ? swiperProductSlider?.dataset.handle : '';
  let thumbsSize = swiperProductThumbs?.querySelectorAll('.swiper-slide').length ? swiperProductThumbs?.querySelectorAll('.swiper-slide').length : 5;
  let centerSlides = false;

  if ( thumbsSize && thumbsSize > 5) {
    centerSlides = true;
  }

    window.MProductSwiperThumbs = new Swiper('#productMainSliderThumbs', {
      modules: [Pagination, Navigation, Thumbs],
      centeredSlides: centerSlides,
      centeredSlidesBounds: centerSlides,
      spaceBetween: 8,
      slidesPerView: 3,
      slidesPerGroup: 1,
      cssMode: true,
      breakpoints: {
        768: {
          slidesPerView: 5
        },
        992: {
          slidesPerView: 5 
        },
      },
      freemode: false,
      watchSlidesProgress: true,
      on: {
        afterInit: function () {
          this.el.classList.remove("jc-opacity-0")
        }
      },
    });

    if (!swiperProductSlider) {
      window.MProductSwiperThumbs = null
    }

    window.MProductSwiper = new Swiper("#productMainSlider", {
      modules: [Pagination, Navigation, Mousewheel, Thumbs],
      slidesPerView: 1,
      initialSlide: 0,
      slideToScroll: 1,
      cssMode: true,
      direction: "horizontal",
      autoHeight: true,
      thumbs: {
        swiper: window.MProductSwiperThumbs
      },
      breakpoints: { 
        992: {
          spaceBetween: 0,
          direction: "vertical",
          slidesPerView: "auto",
          freeMode: true,
          autoHeight: false,
        },
      }
    });


    if (document.querySelector(".video-popup:not(.swiper-initialized)")) {
      window.videoReviewPopup = new Swiper(".video-popup", {
        modules: [ Mousewheel, Pagination, Navigation, EffectFade],
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: false,
        loop: false,
        direction: "vertical",
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: { 
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      })
      window.videoReviewPopup.on('slideChange', function () {
        resetAndPauseVideo();
      });
    }
};


export const mainProductSwiperModal = (query = '') => {
  let swiperProductThumbs = $Q(`${query} .jc-main-product__swiper-thumbs`);
  let swiperProductSlider = $Q(`${query} .jc-main-product__swiper`);
  let swiperProductSliderPagination = $Q(`${query} .jc-main-product__swiper .swiper-pagination`);
  let productHandle = swiperProductSlider?.dataset.handle ? swiperProductSlider?.dataset.handle : '';
  let thumbsSize = swiperProductThumbs.querySelectorAll('.swiper-slide').length;
  let centerSlides = false;

  if (thumbsSize > 4) {
    thumbsSize = 4;
    centerSlides = false;
  }

  window.mainProductSwiperThumbs = new Swiper(swiperProductThumbs, {
    modules: [Pagination, Navigation, EffectFade, Thumbs],
    centeredSlides: centerSlides,
    centeredSlidesBounds: centerSlides,
    slidesPerGroup: 1,
    spaceBetween: 16,
    cssMode: true,
    slidesPerView: thumbsSize,
    threshold: '10px',
    breakpoints: {
      640: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 4
      },
      992: {
        slidesPerView: thumbsSize
      },
    },
    freemode: false,
    watchSlidesProgress: true,
    on: {
      afterInit: function () {
        this.el.classList.remove("jc-opacity-0")
      }
    },
  });

  if (!swiperProductSlider) {
    window.mainProductSwiperThumbs = null
  }


  window.mainSwiperModal = new Swiper(swiperProductSlider,
    {
      modules: [Pagination, Navigation, Thumbs],
      slidesPerView: 1,
      cssMode: true,
      thumbs: {
        swiper: window.mainProductSwiperThumbs
      },
      pagination: {
        el: swiperProductSliderPagination,
        clickable: true
      },
      navigation: {
        nextEl: $Q(`.modal-cart #main-product__swiper-next-${productHandle}`),
        prevEl: $Q(`.modal-cart #main-product__swiper-prev-${productHandle}`),
      }
    });

}

mainProductSwiper();
